import { render, staticRenderFns } from "./itcBatchList.vue?vue&type=template&id=0fad8788"
import script from "./itcBatchList.vue?vue&type=script&lang=js"
export * from "./itcBatchList.vue?vue&type=script&lang=js"
import style0 from "./itcBatchList.vue?vue&type=style&index=0&id=0fad8788&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports